var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5548 1.31346C11.8516 1.61055 12 1.97019 12 2.39237C12 2.79892 11.8516 3.15074 11.5548 3.44783L3.30657 11.7039L0.635279 12.0088C0.447819 12.0244 0.291603 11.9697 0.166631 11.8446C0.0416576 11.7195 -0.013018 11.5631 0.0026036 11.3755L0.307225 8.70168L8.55543 0.445638C8.85225 0.148546 9.20373 0 9.60989 0C10.0317 0 10.391 0.148546 10.6878 0.445638L11.5548 1.31346ZM9.3287 4.62057L7.38381 2.67383L2.13495 7.92767H2.95509V9.0535H4.07984V9.87441L9.3287 4.62057ZM2.95509 11.0002L3.42374 10.5311V9.71023H2.29898V8.5844H1.47885L1.0102 9.0535L0.869603 10.4373L1.57258 11.141L2.95509 11.0002ZM11.0393 2.90838C11.1799 2.76765 11.2502 2.59565 11.2502 2.39237C11.2502 2.17346 11.1799 1.99365 11.0393 1.85292L10.1488 0.961641C10.0082 0.820913 9.8286 0.750549 9.60989 0.750549C9.40681 0.750549 9.23497 0.820913 9.09438 0.961641L7.92276 2.13437L9.86765 4.08111L11.0393 2.90838Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.18db6f69a76f8a253d1f1243e46889d1.svg";
export { ForwardRef as ReactComponent };